import {
  Checkbox,
  Container,
  Group,
  HoverCard,
  Select,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { IconQuestionMark } from "@tabler/icons-react";

import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useCurrentEditorDocument } from "../../hooks/useEditorState";
import { librarySlice } from "../../lib/state/reducer";

export const EditorSettings = (): JSX.Element => {
  const autoCapitalize = useCurrentEditorDocument((state) => state.options.autoCapitalize, "none");
  const includeSimOnlyWarningOption = useCurrentEditorDocument(
    (state) => state.options.includeSimOnlyWarning,
    false
  );
  const includeAttribution = useCurrentEditorDocument(
    (state) => state.options.includeAttributionInFooter,
    false
  );
  const reduxDispatch = useAppDispatch();

  return (
    <Container size="sm">
      <Stack align="flex-start" spacing="xl" mt="xl">
        <Stack align="flex-start" ml="md" style={{ width: "100%" }}>
          <Select
            label="Display in ALL CAPS"
            value={autoCapitalize}
            data={[
              { value: "none", label: "None" },
              { value: "checklist-item", label: "Checklist Item" },
              { value: "checklist-setting", label: "Checklist Setting" },
              { value: "both", label: "Both" },
            ]}
            onChange={(newValue) => {
              if (
                newValue === "none" ||
                newValue === "checklist-item" ||
                newValue === "checklist-setting" ||
                newValue === "both"
              ) {
                reduxDispatch(
                  librarySlice.actions.setDocumentOptions({ autoCapitalize: newValue })
                );
              }
            }}
          />
          <Group spacing="xs">
            <Checkbox
              label={<Text>Include "For flight simulation use only" warning in footer</Text>}
              checked={includeSimOnlyWarningOption}
              onChange={(e) =>
                reduxDispatch(
                  librarySlice.actions.setDocumentOptions({
                    includeSimOnlyWarning: e.target.checked,
                  })
                )
              }
            />
            <HoverCard
              width={280}
              openDelay={500}
              withArrow
              position="top"
              styles={(theme) => ({
                arrow: {
                  backgroundColor: theme.colors.gray[1],
                  border: `1px solid ${theme.colors.dark[1]}`,
                },
                dropdown: {
                  backgroundColor: theme.colors.gray[1],
                  border: `1px solid ${theme.colors.dark[1]}`,
                },
              })}
            >
              <HoverCard.Target>
                <ThemeIcon size="md" variant="light" radius="xl">
                  <IconQuestionMark size={14} stroke={3} />
                </ThemeIcon>
              </HoverCard.Target>
              <HoverCard.Dropdown>
                <Text size="sm">Only shows in rendered PDFs. May not show in preview. Sorry!</Text>
              </HoverCard.Dropdown>
            </HoverCard>
          </Group>
          <Group spacing="xs">
            <Checkbox
              label={<Text>Include "Created with fs-checklist.studio" in the footer</Text>}
              checked={includeAttribution}
              onChange={(e) =>
                reduxDispatch(
                  librarySlice.actions.setDocumentOptions({
                    includeAttributionInFooter: e.target.checked,
                  })
                )
              }
            />
            <HoverCard
              width={280}
              openDelay={500}
              withArrow
              position="top"
              styles={(theme) => ({
                arrow: {
                  backgroundColor: theme.colors.gray[1],
                  border: `1px solid ${theme.colors.dark[1]}`,
                },
                dropdown: {
                  backgroundColor: theme.colors.gray[1],
                  border: `1px solid ${theme.colors.dark[1]}`,
                },
              })}
            >
              <HoverCard.Target>
                <ThemeIcon size="md" variant="light" radius="xl">
                  <IconQuestionMark size={14} stroke={3} />
                </ThemeIcon>
              </HoverCard.Target>
              <HoverCard.Dropdown>
                <Text size="sm">Only shows in rendered PDFs. May not show in preview. Sorry!</Text>
              </HoverCard.Dropdown>
            </HoverCard>
          </Group>
        </Stack>
      </Stack>
    </Container>
  );
};
